<template>
	<div class="full box flex" ref="uploadvouchercontainer">
		<div style="flex: 1;">
			<div ref="uploadvoucher" style="margin-top: 20px;"></div>
		</div>
		<div>
			<van-button type="primary" @click="submit(true)" style="width: 50%;">提交并继续</van-button>
			<van-button type="info" @click="submit(false)" style="width: 50%;">仅提交</van-button>
		</div>
		
	</div>
</template>
<style scoped>
	.box {
		box-sizing: border-box;
		padding: 10px 10px;
		overflow: auto;
		flex-direction: column;
	}

	.item {
		flex-direction: row;
		align-items: center;
	}
</style>
<script>
	const formRes = {
		title: '表单',
		rule: {
			"width": "100%",
			"height": "auto",
			"fApi": [],
			"rule": [{
					"type": "el-divider",
					"children": [
						"采购单凭证上传"
					]
				}, {
					"type": "$input",
					"field": "stockCode",
					"title": "单据编码",
					"value": "123",
					"hidden": false,
					"props": {
						"readonly": true
					},
					"validate": [{
						"required": true,
						"message": "必填项"
					}]
				},
				{
					"type": "$upload",
					"field": "file_path",
					"title": "凭证",
					"value": null,
					"hidden": false,
					"props": [],
					"validate": [{
						"required": false,
						"message": "必填项"
					}]
				}
			],
			"option": {
				"form": {
					"title": false,
					"labelWidth": "80px",
					"hideRequiredAsterisk": false,
					"showMessage": false,
					"inlineMessage": false
				},
				"global": {
					"*": {
						"props": {
							"el": true,
							"size": "small",
							"disabled": false
						},
						"col": {
							"span": 24,
							"offset": 0
						}
					}
				},
				"submitBtn": false,
				"resetBtn": false
			}
		}
	}
	export default {
		props: {
			param: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				fApi: null,
				title: '',
				rule: null,
				sourcedata:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			this.init()
		},
		computed: {

		},

		methods: {
			init() {
				let handle = this.$loading(this.$refs.uploadvouchercontainer)
				this.$api.purchasevoucher.list({
					id: this.param.relationid,
					searchvague:0
				}).then((res)=>{
					this.$loadingclose(handle)
					if(!res.list.length){
						this.$message.error('未查询到单据')
						return
					}
					let data = res.list[0]		
					this.sourcedata = data
					let _formRes = JSON.parse(JSON.stringify(formRes))
					this.rule = _formRes.rule
					this.title = _formRes.title
					let option = this.rule.option
					option.el = this.$refs.uploadvoucher
					this.fApi = this.$formCreate(this.rule.rule, option)
					this.fApi.nextTick(() => {
						this.fApi.setValue('stockCode', data.stockCode)
						this.fApi.setValue('file_path', data.file_path)
					})
				},()=>{
					this.$loadingclose(handle)
				})
			},
			submit(iscontinue) {
				this.$api.purchasevoucher.uploadvoucher({
					id:this.sourcedata.id,
					file_path: this.fApi.getValue('file_path'),
				}).then(() => {
					this.$message.success('操作成功')
					this.$emit('submit',{continue:iscontinue})
				})
			}
		},
		components: {

		}
	}
</script>